export const ADD_BRANCH = "ADD_BRANCH";
export const GET_BRANCHES = "GET_BRANCHES";
